import { render, staticRenderFns } from "./AddVirtualPoi.vue?vue&type=template&id=837dc9f8&scoped=true"
import script from "./AddVirtualPoi.vue?vue&type=script&lang=ts"
export * from "./AddVirtualPoi.vue?vue&type=script&lang=ts"
import style0 from "./AddVirtualPoi.vue?vue&type=style&index=0&id=837dc9f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837dc9f8",
  null
  
)

export default component.exports